import { motion } from "framer-motion";
import { Heart, Brain, User, UserCircle, Briefcase, Globe2, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ICON_MAP = { Heart, Brain, User, UserCircle, Briefcase, Globe2 };

export default function Categories() {
  const { t } = useLanguage();

  return (
    <section
      id="categories"
      data-testid="categories-section"
      className="py-24 md:py-32 bg-[#0A0A0A] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <p className="overline">{t.categories.overline}</p>
            <h2 className="font-display uppercase mt-4 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              {t.categories.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-white/65 text-base md:text-lg leading-relaxed max-w-xl">
              {t.categories.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {t.categories.items.map((item, idx) => {
            const Icon = ICON_MAP[item.icon] || Heart;
            return (
              <motion.a
                key={item.slug}
                href="#podcast"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.55,
                  delay: idx * 0.06,
                  ease: [0.22, 1, 0.36, 1],
                }}
                data-testid={`category-card-${item.slug}`}
                className="group bg-[#0F0F0F] p-7 md:p-9 min-h-[260px] flex flex-col justify-between relative transition-colors hover:bg-[#161616]"
              >
                <div className="flex items-start justify-between">
                  <Icon
                    size={30}
                    strokeWidth={1.4}
                    className="text-redflag transition-transform group-hover:scale-110"
                  />
                  <ArrowUpRight
                    size={20}
                    className="text-white/30 group-hover:text-redflag group-hover:rotate-12 transition-all"
                  />
                </div>
                <div>
                  <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight text-white">
                    {item.title}
                  </h3>
                  <div className="mt-2 font-mono-plex text-[11px] uppercase tracking-widest text-white/40">
                    {item.tags}
                  </div>
                  <p className="mt-4 text-sm md:text-base text-white/65 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
